import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables';

import { NavBar, HelperViewStatus } from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';

import { ESuggestedPortfolioBuilderSteps } from '@/modules/wealth/views/SuggestedPortfolioBuilder/helpers';
import { inject } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HandleError',
  setup(__props) {

const router = useRouter();

const changeStep = inject(
  'changeStep',
  (step: ESuggestedPortfolioBuilderSteps) => ({ step })
);

function retry() {
  changeStep(ESuggestedPortfolioBuilderSteps.GOAL_DATE);
}

function back() {
  router.push({ name: 'wealthWalletSelection' });
}

return { __sfc: true,router, changeStep, retry, back, NavBar, HelperViewStatus, BackButton }
}

})